import { useTranslation } from 'react-i18next'

import { Status } from '../../../Status'
import { FilePreviewErrorTooltipText } from '../../FilePreviewErrorTooltipText'

import * as styles from './FileAttachTagStatuses.module.css'

function FileAttachTagStatuses({ file, height, link, onClickError }) {
  const { t } = useTranslation()

  return (
    <div className={styles.statuses}>
      {file?.error ? (
        <Status
          height={height}
          text={t('Error.FileUploadKey')}
          textColor='var(--color-error)'
          tooltip={<FilePreviewErrorTooltipText file={file} />}
          onClick={onClickError}
        />
      ) : null}
      {file?.link || link ? (
        <Status
          height={height}
          text={t('File.LinkedFileTagKey')}
          textColor='var(--secondary-text-color)'
        />
      ) : null}
    </div>
  )
}

export default FileAttachTagStatuses
